/**
 * Configuration SOAP
 *
 * @author Guillaume TRAVOT
 * @date 11/02/2026
 */
export class ConfigurationSoap {
    url: string;
    identifiant: string;
    password: string;
    passwordEncrypted: string;

    constructor(dto?: any) {
        if (dto) {
            this.url = dto.url;
            this.identifiant = dto.identifiant;
            this.password = dto.password;
            this.passwordEncrypted = dto.passwordEncrypted;
        }
    }
}